export default __webpack_public_path__ + "static/media/ss.2a4a236a.svg";